import script from "./SensoriUmiditaEventi.vue?vue&type=script&setup=true&lang=js"
export * from "./SensoriUmiditaEventi.vue?vue&type=script&setup=true&lang=js"

import "./SensoriUmiditaEventi.vue?vue&type=style&index=0&id=b795c4aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b795c4aa"]])

export default __exports__